import React from 'react';
import { Col } from '@themesberg/react-bootstrap';
import ColorComponent from './ColorComponent';
import TableLinkComponent from './TableLinkComponent';
const Labels = ({ keyName, value, colored = false, link }) => {
  let Comoponent = <h6>{value ?? ''}</h6>;
  if (colored) Comoponent = <ColorComponent value={value} />;
  if (link)
    Comoponent = <TableLinkComponent value={value} underline onClick={link} />;
  return (
    <Col md={4} className='mb-3'>
      <h6>{keyName ?? ''}:</h6>

      {Comoponent}
    </Col>
  );
};

export default Labels;
